// src/services/pranthService.js

export const fetchPranthList = async () => {
    try {
        // Normally you would fetch from API:
        // const res = await axiosPrivate.get("list-pranths");
        // return res.data;

        // For now, return hardcoded list
        return [
            { id: "1", name: "ഉത്തര കേരളം" },
            // { id: "2", name: "ദക്ഷിണ കേരളം" },
        ];
    } catch (err) {
        console.error("Failed to fetch pranths", err);
        // return [
        //     { id: "1", name: "ഉത്തര കേരളം" },
        //     { id: "2", name: "ദക്ഷിണ കേരളം" },
        // ];
    }
};
